/**
 * Split a blog post's comma-separated `tags` string into individual, trimmed
 * tags. Handles both the ASCII comma `,` and the Arabic comma `،`, and drops
 * empty entries (including the leading-comma artifact some posts carry).
 */
export const splitTags = (tags: string | null | undefined): string[] =>
  (tags ?? "")
    .split(/[,،]/)
    .map((t) => t.trim())
    .filter(Boolean);
